/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { TRACKING_UTM_COOKIES_MAX_AGE, TRACKING_UTM_PARAMS } from '@/analytics/CookieBanner/types'

function getUtmParamsCookieData({ name, value, domain }: { name: string; value: any; domain: string }) {
  return [
    `tracking_${name}`,
    value,
    {
      maxAge: TRACKING_UTM_COOKIES_MAX_AGE,
      secure: true,
      path: '/',
      domain: `.${domain}`,
    },
  ] as const
}

function setUtmCookies(
  cookies: { set: (name: string, value: any, options: any) => any },
  domain: string,
  params: { get(key: string): any }
) {
  for (const name of TRACKING_UTM_PARAMS) {
    const value = params.get(name)
    if (!value) continue
    cookies.set(...getUtmParamsCookieData({ name, domain, value }))
  }
}

export default setUtmCookies
